import React from "react";
import { AppContext } from "../context/app-context";

const useUserData = () => {
  const { user, setUser, setRefetch } = React.useContext(AppContext);
  return { user, setUser, setRefetch };
};

export default useUserData;
